<template>
  <div class="index" v-cloak>
    <!-- <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div> -->
    <div class="header acea-row row-center-wrapper">
      <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <!-- <div class="quality-product">
      <ul>
        <li>
          <img src="@assets/moblie/images/zxkx.png" class="icon" />遵循科學
        </li>
        <li>
          <img src="@assets/moblie/images/aqfx.png" class="icon" />安全放心
        </li>
        <li>
          <img src="@assets/moblie/images/djsq.png" class="icon" />獨家授權
        </li>
        <li>
          <img src="@assets/moblie/images/zjtj.png" class="icon" />專家推薦
        </li>
      </ul>
    </div> -->
    <!-- <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div> -->

    <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activityOne.wap_link !== undefined || activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        v-if="activityOne.wap_link !== undefined"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 口罩专区 -->
    <!--
    <div class="mask-box">
      <router-link to="/maskList">
        <img src="../../../assets/moblie/images/mask.png" alt="" />
      </router-link>
    </div>
    <div class="wrapper" v-if="info.fastList.length > 0">
      <div class="title acea-row row-between-wrapper change-align">
        <div class="text">
          <div class="name line1">专科选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="category-box">
        <div
          class="category-box--item"
          v-for="(item, index) in info.fastList.slice(0, 8)"
          :key="index"
        >
          <router-link
            :to="{
              path: '/goods_list',
              query: { id: item.id, title: item.cate_name }
            }"
          >
            <div class="img">
              <img :src="item.pic" alt="" />
            </div>
            <div class="tip">{{ item.cate_name }}</div>
          </router-link>
        </div>
      </div>
    </div>
  -->
    <!-- <div class="hot-list wrapper" v-if="likeInfo.length > 0">
      <div class="title acea-row row-between-wrapper change-align">
        <div class="text">
          <div class="name line1">热门榜单</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="hot-content">
        <div class="hot-item" v-for="item of hotNewList" :key="item.id">
          <div class="img">
            <img :src="item.image" alt="" />
          </div>
          <div class="tip-box">
            <div>{{ item.store_name }}</div>
            <div>${{ item.price }}</div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="wrapper" v-if="info.bastList.length > 0">
      <!-- <div class="title acea-row row-between-wrapper change-align">
        <div class="text">
          <div class="name line1">精品推薦</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
          <view
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </view>
        <div class="swiper-pagination paginationBoutique"></div>
      </div> -->
      <Good-list :good-list="info.bastList" :is-sort="false" :isTyrvaya="false"></Good-list>
      <Good-list :good-list="info.bastList" :is-sort="false" :isTyrvaya="true" v-if="info.isTyrvaya"></Good-list>
    </div>
    <!-- <div v-else-if="info.bastList.length == 0 && isLogin" class="login-panel">
      <div>暂无商品，请联系客服</div>
    </div> -->
    <div v-else class="login-panel">
      <div>您还未登录，请先</div>
      <div class="to-login" @click="switchLogin">登录</div>
    </div>
    <div class="news-container">
      <div class="news">
        <div class="pictrue"><img src="@assets/moblie/images/news.png" /></div>
        <div class="swiper-no-swiping new-banner">
            <view
              class="swiper-slide"
              v-for="(item, index) in roll"
              :key="index"
            >
              <router-link
                :to="item.wap_url ? item.wap_url : ''"
                class="acea-row row-between-wrapper"
              >
                <div class="text acea-row row-between-wrapper">
                  <div class="label" v-if="item.show === '是'">最新</div>
                  <div class="newsTitle line1">{{ item.info }}</div>
                </div>
                <div class="iconfont icon-xiangyou"></div>
              </router-link>
            </view>
        </div>
      </div>
      <div class="blocks">
        <div class="about-letuopin" @click="$router.push('/about-letuopin')">
          <div class="blocks-title">关于乐托品</div>
          <div class="to-detail">
            <div>详情</div>
            <div class="iconfont icon-xiangyou"></div>
          </div>
        </div>
        <div class="hangye-info" @click="$router.push('/news_list?id=2')">
          <div class="blocks-title">用药指南</div>
          <div class="to-detail">
            <div>详情</div>
            <div class="iconfont icon-xiangyou"></div>
          </div>
        </div>
        <div class="about-us" @click="$router.push('/news_list?id=1')">
          <div class="blocks-title">科普知识</div>
          <div class="to-detail">
            <div>详情</div>
            <div class="iconfont icon-xiangyou"></div>
          </div>
        </div>
        <div class="changjianwenti" @click="$router.push('/questions')">
          <div class="blocks-title">常見問題</div>
          <div class="to-detail">
            <div>详情</div>
            <div class="iconfont icon-xiangyou"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img
              src="@assets/moblie/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/moblie/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/moblie/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">****</span>
          </div>
        </router-link>
      </div>
    </div> -->
    <div v-if="newGoodsBananr">
      <div class="adver">
        <img :src="newGoodsBananr" />
      </div>
    </div>
    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首發新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <div @click="goDetail(item)">
              <div class="img-box">
                <img :src="item.image" />
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '1'"
                  >秒杀</span
                >
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '2'"
                  >砍价</span
                >
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '3'"
                  >拼团</span
                >
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">￥****</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促銷單品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/promotion'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/moblie/css/swiper.min.css";
import GoodList from "@components/moblie/GoodList";
import PromotionGood from "@components/moblie/PromotionGood";
import CouponWindow from "@components/moblie/CouponWindow";
import { getHomeData, getShare, follow } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow
  },
  props: {},
  computed: {
    ...mapGetters(["isLogin"]),
    hotNewList() {
      let newList = [...this.likeInfo];
      let middleVal = newList.splice(1, 1);
      newList.unshift(...middleVal);
      return newList;
    }
  },
  data: function() {
    return {
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
        isTyrvaya: false
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      mapKey: ""
    };
  },
  created() {
    vm = this;
    console.log(isWeixin());
  },
  mounted: function() {
    this.getFollow();
    let that = this;
    console.log("denglu");
    console.log(this.isLogin);
    let spread = this.$route.query.spread; //提供绑定上下级的id 2019-11-22
    console.log(spread);
    getHomeData(spread)
      .then(res => {
        that.mapKey = res.data.tengxun_map_key;
        cookie.set(MAPKEY, that.mapKey);
        that.logoUrl = res.data.logoUrl;
        that.newGoodsBananr = res.data.newGoodsBananr;
        that.$set(that, "banner", res.data.banner);
        that.$set(that, "menus", res.data.menus);
        that.$set(that, "roll", res.data.roll);
        that.$set(that, "activity", res.data.activity);
        if (res.data.activity.length) {
          var activityOne = res.data.activity.shift();
          that.$set(that, "activityOne", activityOne);
        }
        that.$set(that, "info", res.data.info);
        that.$set(that, "likeInfo", res.data.likeInfo);
        that.$set(
          that,
          "lovely",
          res.data.lovely.length ? res.data.lovely[0] : {}
        );
        that.$set(that, "benefit", res.data.benefit);
        that.$set(that, "couponList", res.data.couponList);

        if (that.isLogin) {
          that.subscribe = res.data.subscribe;
          if (!that.subscribe && that.followUrl) {
            let timer = setTimeout(function() {
              that.followHid = true;
            }, 200);
            clearTimeout(timer);
          } else {
            that.followHid = false;
          }
        } else {
          that.followHid = false;
        }

        if (res.data.site_name) document.title = res.data.site_name;
        that.setOpenShare();
        this.showCoupon =
          !cookie.has(HAS_COUPON_WINDOW) &&
          res.data.couponList.some(coupon => coupon.is_use);
        //if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
      })
      .catch(e => {
        console.log("授权失败");
        console.log(e);
        that.$dialog.error("授权失败");
      });
  },
  methods: {
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    switchLogin() {
      this.$router.push("/user");
    },
    // 商品详情跳转
    goDetail(item) {
      if (item.activity && item.activity.type === "1") {
        this.$router.push({
          path:
            "/activity/seckill_detail/" +
            item.activity.id +
            "/" +
            item.activity.time +
            "/1"
        });
      } else if (item.activity && item.activity.type === "2") {
        this.$router.push({
          path: "/activity/dargain_detail/" + item.activity.id
        });
      } else if (item.activity && item.activity.type === "3") {
        this.$router.push({
          path: "/activity/group_detail/" + item.activity.id
        });
      } else {
        this.$router.push({ path: "/detail/" + item.id });
      }
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暫無法使用查看地圖，請配置您的騰訊地圖key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.index {
  background-color: #f4fafe;
  height: 100%;
}

.index .follow {
  z-index: 100000;
}
.index .login-panel {
  text-align: center;
  padding: 0.3rem;
  box-sizing: border-box;
  color: #ffffff;
}
.index .login-panel .to-login {
  margin: 0.2rem;
  padding: 0.2rem;
  background-color: #ffffff;
  color: rgb(64, 105, 255);
  border-radius: 0.1rem;
}
.news-container {
  background-color: #fff;
  padding: 0.3rem;
  padding-top: 0;
  padding-bottom: 0.5rem;
  border-radius: 10px;
  z-index: 9;
  margin: 30px 0;
}
.news-container .iconfont {
  font-size: 0.2rem;
}
.news {
  display: flex;
  align-items: center;
  border-bottom: 1px rgb(242, 242, 242) solid;
}
.blocks {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0.3rem 0;
  padding-bottom: 0;
  height: 2.7rem;
  flex-wrap: wrap;
}
.blocks .about-letuopin {
  background-image: url(../../../assets/moblie/images/about-letuopin.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 4px 0 4px 4px;
  border-radius: 12px;
  width: 45%;
  height: 48%;
  box-sizing: border-box;
}
.blocks-title {
  font-size: 0.35rem;
  color: #fff;
}
.to-detail {
  display: flex;
  align-items: flex-end;
  margin-top: 1px;
  color: white;
  border: 1px white solid;
  border-radius: 16px;
  padding: 1px 4px;
  width: 50px;
  box-sizing: border-box;
  font-size: 0.2rem;
}
.hangye-info {
  background-image: url(../../../assets/moblie/images/yongyaozhinan.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 4px 0 0 10px;
  border-radius: 12px;
  width: 45%;
  box-sizing: border-box;
  height: 48%;
}
.about-us {
  background-image: url(../../../assets/moblie/images/kepuzhishi.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 4px 0 0 10px;
  border-radius: 12px;
  width: 45%;
  box-sizing: border-box;
  height: 48%;
}
.changjianwenti {
  background-image: url(../../../assets/moblie/images/changjianwenti.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 4px 0 0 10px;
  border-radius: 12px;
  width: 45%;
  box-sizing: border-box;
  height: 48%;
}
.quality-product {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #f7f7f7;
}
.quality-product ul {
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  height: 0.8rem;
}
.quality-product .icon {
  width: 0.3rem;
  height: 0.3rem;
}
.quality-product ul li {
  color: #a9b0b8;
  text-align: center;
}
.quality-product ul li .mr {
  margin-right: 0.1rem;
}
/* 重置 */
.acea-row.row-between-wrapper.change-align {
  align-items: inherit;
}
.index .wrapper .title .text .name {
  font-size: 0.32rem;
  margin-bottom: 0.1rem;
}
.index .wrapper .title .more {
  line-height: 24px;
  color: #898a8c;
}
.category-box {
  padding: 0.3rem;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 0.15rem;
}
.category-box .category-box--item {
  width: 1.6rem;
  height: 1.6rem;
  background: #eff6ff;
  border-radius: 1px;
  margin-bottom: 0.15rem;
  text-align: center;
  margin-right: 0.15rem;
}
.category-box .category-box--item:nth-child(4n) {
  margin-right: 0;
}
.category-box .category-box--item .img {
  width: 0.8rem;
  height: 0.8rem;
  margin: 0 auto;
  margin-top: 0.25rem;
}
.category-box .category-box--item .img img {
  width: 100%;
  height: 100%;
}
.category-box .category-box--item .tip {
  font-size: 0.24rem;
  margin-top: 0.12rem;
}
.hot-list .hot-content {
  margin: 0.3rem;
  height: 4.5rem;
  background-image: url("../../../assets/moblie/images/list-bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
}
.hot-list .hot-content .hot-item {
  width: 33.33%;
  text-align: center;
}
.hot-list .hot-content .hot-item:nth-child(2) .img {
  margin-top: 0.65rem;
  transform: translateX(0px);
  margin-bottom: 1.5rem;
}
.hot-list .hot-content .hot-item .img {
  width: 0.75rem;
  height: 0.75rem;
  background: red;
  margin: 0 auto;
  margin-top: 1.2rem;
  transform: translateX(-2px);
}
.hot-list .hot-content .hot-item .img img {
  width: 100%;
  height: 100%;
}
.hot-list .hot-content .hot-item .tip-box {
  margin-top: 1.5rem;
}
.hot-list .hot-content .hot-item .tip-box div:first-child {
  color: #202121;
  padding: 0 10px;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.hot-list .hot-content .hot-item .tip-box div:last-child {
  color: #ff4040;
  margin-top: 0.2rem;
}
.mask-box {
  margin: 0 0.3rem 0.2rem;
  border-radius: 0.1rem;
}
.mask-box img {
  width: 100%;
}
</style>
